import { MenuGroup } from '@interfaces';

function buildMenuGroups(props: any): MenuGroup[] {
  if (!props?.menuGroups || !props?.menuGroups.length) return [];

  return props.menuGroups;
}

export default buildMenuGroups;
